/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Notifications: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.73861 8.48637C8.14804 6.45835 9.93023 5 11.9992 5C14.0682 5 15.8505 6.45832 16.2601 8.48638L17.7288 15.759C17.754 15.8836 17.6587 16 17.5316 16H11.9997H6.46751C6.34044 16 6.24522 15.8836 6.27036 15.7591L7.73861 8.48637ZM11.9992 3C8.97823 3 6.37599 5.12939 5.77817 8.09059L4.30992 15.3633C4.03472 16.7264 5.07687 18 6.46751 18H11.9997H17.5316C18.9224 18 19.9646 16.7263 19.6892 15.363L18.2205 8.09045C17.6224 5.12928 15.0201 3 11.9992 3ZM9.99955 19.5002C9.44726 19.5002 8.99955 19.9479 8.99955 20.5002C8.99955 21.0525 9.44726 21.5002 9.99955 21.5002H11.9995H13.9995C14.5518 21.5002 14.9995 21.0525 14.9995 20.5002C14.9995 19.9479 14.5518 19.5002 13.9995 19.5002H11.9995H9.99955Z'
      fill='currentColor'
    />
  </React.Fragment>
)
